import React, { useContext, useState } from 'react';

import styled from '@emotion/styled';

import useUpdateDispatcherProfile from '../../../../hooks/dashboard/driver-list/useUpdateDispatcherProfile';
import {
  UpdateDispatcherImageDataType,
  UpdateDispatcherImageInitialValues,
  UpdateDispatcherImageSchema,
} from '../../../../models/dashboard/driver-list/update-driver-image';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import ImageUploadField from '../../../FormCom/ImageUploadField';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface UpdateDispatcherImageModalProps {
  data: any;
}

const UpdateDispatcherImageModal: React.FC<UpdateDispatcherImageModalProps> = ({
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { updateDispatcherProfile, loading } = useUpdateDispatcherProfile();
  const [defaultImgUrl, setDefaultImgUrl] = useState<string | null>(null);

  const onSubmit = (values: UpdateDispatcherImageDataType, actions: any) => {
    updateDispatcherProfile(values, data.driverId, () => {
      actions.resetForm();
      modalContext?.setShowModal(true);
      tableContext?.setRefreshTable(!tableContext.refreshTable);
    });
  };

  return (
    <ModalContainer label='Upload Driver Image'>
      <FormComponent
        initialValues={UpdateDispatcherImageInitialValues}
        schema={UpdateDispatcherImageSchema}
        onSubmit={onSubmit}
      >
        <ImageUploadField
          id='profilePicture'
          name='profilePicture'
          defaultImgUrl={defaultImgUrl}
          setDefaultImgUrl={setDefaultImgUrl}
        />

        <FormRow>
          <FormSubmitButton loading={loading} className='fit '>
            Upload Image
          </FormSubmitButton>
        </FormRow>
      </FormComponent>
    </ModalContainer>
  );
};

export default UpdateDispatcherImageModal;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
`;
